var map = {
	"./baac.png": 199,
	"./bay.png": 702,
	"./bbl.png": 5188,
	"./cimb.png": 9329,
	"./citi.png": 6838,
	"./ghb.png": 5082,
	"./gsb.png": 8877,
	"./ibank.png": 107,
	"./kbank.png": 5490,
	"./kk.png": 1130,
	"./ktb.png": 8006,
	"./lhb.png": 8358,
	"./promptpay.png": 2303,
	"./scb.png": 2779,
	"./tcrb.png": 8284,
	"./tisco.png": 843,
	"./ttb.png": 3397,
	"./uob.png": 7082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8004;